import { render } from "./EditableDataList.vue?vue&type=template&id=8786acc2"
import script from "./EditableDataList.vue?vue&type=script&lang=js"
export * from "./EditableDataList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__